//// Neoffice — added file (shop assistant, no upstream equivalent).
// The chat bubble. Everything it says comes from the server (`get_config`
// carries the labels: website pages have no __() catalogue), everything it
// knows about the visitor comes from the session behind the requests. The
// bubble only draws, sends and shows.
frappe.provide("webshop.assistant");

webshop.assistant = {
	config: null,
	busy: false,
	el: {},

	//// Neoffice ▼▼▼ — lot C of the 2026-10-30 audit. Every page view used to ask the server for the bubble
	//// (`get_config` looks a conversation up), a crawler's or a probe's as well as a person's. The page now asks
	//// once a visitor shows up — a touch, a key, a scroll — or, for somebody who only reads, after a quiet while.
	//// A visitor who had the bubble open on the previous page finds it at once.
	SIGNS_OF_A_VISITOR: ["pointerdown", "pointermove", "keydown", "scroll", "touchstart", "wheel"],
	QUIET_WHILE_MS: 6000,

	whenWanted(start) {
		let started = false;
		let timer = null;
		const go = () => {
			if (started) return;
			started = true;
			this.SIGNS_OF_A_VISITOR.forEach((sign) => window.removeEventListener(sign, go));
			clearTimeout(timer);
			start();
		};
		this.SIGNS_OF_A_VISITOR.forEach((sign) => window.addEventListener(sign, go, { passive: true }));
		timer = setTimeout(go, this.QUIET_WHILE_MS);
	},

	wasOpen() {
		try {
			return sessionStorage.getItem("wsh-assistant-open") === "1";
		} catch (e) {
			return false;
		}
	},
	//// Neoffice ▲▲▲

	async init() {
		if (document.getElementById("wsh-assistant")) return;
		let config;
		try {
			config = await this.api("webshop.webshop.assistant.api.get_config", { page_route: this.route() }, "GET");
		} catch (e) {
			return;
		}
		if (!config || !config.enabled) return;
		this.config = config;
		this.build();
		this.renderHistory();
		if (sessionStorage.getItem("wsh-assistant-open") === "1") this.open(false);
	},

	route() {
		return location.pathname.replace(/^\//, "");
	},

	//// Neoffice — the bubble asks the server with its own fetch (lot A of the 2026-10-30 audit). It was
	//// frappe.call, which never ends its promise on a 429: the error callback is not called (measured on a
	//// shop page: only `always` fires), so a visitor who met a limit saw "typing…" for ever, under a Frappe
	//// dialog in the middle of the page. A request here always ends: with the message, or with an error that
	//// carries `status` and `responseJSON` (what serverMessage() reads).
	async api(method, args, type) {
		const verb = type || "POST";
		const params = new URLSearchParams();
		Object.entries(args || {}).forEach(([key, value]) => {
			if (value !== undefined && value !== null) params.append(key, value);
		});
		const headers = { Accept: "application/json" };
		if (frappe.csrf_token) headers["X-Frappe-CSRF-Token"] = frappe.csrf_token;
		const url = "/api/method/" + method;
		const response =
			verb === "GET"
				? await fetch(`${url}?${params}`, { headers, credentials: "same-origin" })
				: await fetch(url, {
						method: verb,
						headers: { ...headers, "Content-Type": "application/x-www-form-urlencoded" },
						body: params,
						credentials: "same-origin",
				  });
		const data = await response.json().catch(() => ({}));
		if (!response.ok) {
			const error = new Error(`HTTP ${response.status}`);
			error.status = response.status;
			error.responseJSON = data;
			throw error;
		}
		return data.message;
	},

	build() {
		const c = this.config;
		const L = c.labels;
		const root = document.createElement("div");
		root.id = "wsh-assistant";
		root.className = "wsh-assistant" + (c.position === "Bottom left" ? " wsh-assistant--left" : "");
		if (c.color) root.style.setProperty("--wsh-assistant-color", c.color);
		root.innerHTML =
			`<button type="button" class="wsh-assistant__bubble" aria-label="${this.escape(L.open)}" aria-expanded="false">` +
			`<span class="wsh-assistant__bubble-icon" aria-hidden="true">${this.icon()}</span></button>` +
			`<section class="wsh-assistant__panel" role="dialog" aria-label="${this.escape(c.name)}" hidden>` +
			`<header class="wsh-assistant__head"><span class="wsh-assistant__avatar" aria-hidden="true">${this.icon()}</span>` +
			`<span class="wsh-assistant__name">${this.escape(c.name)}</span>` +
			`<button type="button" class="wsh-assistant__reset" title="${this.escape(L.new_conversation)}">↺</button>` +
			`<button type="button" class="wsh-assistant__close" aria-label="${this.escape(L.close)}">×</button></header>` +
			`<div class="wsh-assistant__messages" aria-live="polite"></div>` +
			`<div class="wsh-assistant__suggestions"></div>` +
			`<form class="wsh-assistant__form"><input class="wsh-assistant__input" type="text" maxlength="1000" autocomplete="off" placeholder="${this.escape(L.placeholder)}">` +
			`<button type="submit" class="wsh-assistant__send">${this.escape(L.send)}</button></form>` +
			`<div class="wsh-assistant__foot"><button type="button" class="wsh-assistant__team">${this.escape(L.talk_to_team)}</button>` +
			//// Neoffice — lot E of the 2026-10-30 audit: the visitor is told while anonymised samples are kept; the server sends the sentence only then
			(c.consent ? `<p class="wsh-assistant__consent">${this.escape(c.consent)}</p>` : "") +
			`</div>` +
			`</section>`;
		document.body.appendChild(root);
		this.el = {
			root,
			bubble: root.querySelector(".wsh-assistant__bubble"),
			panel: root.querySelector(".wsh-assistant__panel"),
			messages: root.querySelector(".wsh-assistant__messages"),
			suggestions: root.querySelector(".wsh-assistant__suggestions"),
			form: root.querySelector(".wsh-assistant__form"),
			input: root.querySelector(".wsh-assistant__input"),
			team: root.querySelector(".wsh-assistant__team"),
			reset: root.querySelector(".wsh-assistant__reset"),
			close: root.querySelector(".wsh-assistant__close"),
		};
		this.el.bubble.addEventListener("click", () => (this.el.panel.hidden ? this.open() : this.closePanel()));
		this.el.close.addEventListener("click", () => this.closePanel());
		this.el.form.addEventListener("submit", (e) => {
			e.preventDefault();
			this.send(this.el.input.value);
		});
		//// Neoffice — was: the link sent the last suggestion through the model, so a model
		//// outage also cut the customer off from the team. It now opens the direct form.
		this.el.team.addEventListener("click", () => {
			this.showLeaveForm("", !this.config.signed_in);
			this.scroll();
		});
		this.el.reset.addEventListener("click", () => this.reset());
		//// Neoffice — the opinion buttons are drawn under each answer, so one handler listens for all of them (lot D of the 2026-10-30 audit)
		this.el.messages.addEventListener("click", (event) => {
			const button = event.target.closest && event.target.closest("[data-rating]");
			if (button) this.onRate(button);
		});
	},

	//// Neoffice ▼▼▼ — lot D of the 2026-10-30 audit. Under each answer the visitor can say whether it helped, or report
	//// it. What the shop learns is which answers did not help; the visitor's words stay where they are. The icons are
	//// drawn (an emoji looks different on every platform), take the ink of the message and are named for a screen reader.
	THUMB_UP: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>',
	THUMB_DOWN: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"/></svg>',

	rateRowHtml(id, feedback, reported) {
		const L = this.config.labels;
		const choice = (rating, label, icon) =>
			`<button type="button" class="wsh-assistant__rate-btn" data-rating="${rating}" aria-label="${this.escape(label)}" title="${this.escape(label)}" aria-pressed="${feedback === rating}">${icon}</button>`;
		return (
			`<div class="wsh-assistant__rate" data-id="${this.escape(id)}">` +
			choice("up", L.useful, this.THUMB_UP) +
			choice("down", L.not_useful, this.THUMB_DOWN) +
			`<button type="button" class="wsh-assistant__rate-report" data-rating="report"${reported ? " disabled" : ""}>${this.escape(L.report)}</button>` +
			`</div>`
		);
	},

	rate(id, rating) {
		return this.api("webshop.webshop.assistant.api.rate_message", { message: id, rating });
	},

	async onRate(button) {
		const box = button.closest(".wsh-assistant__rate");
		const rating = button.dataset.rating;
		const buttons = Array.from(box.querySelectorAll("button"));
		buttons.forEach((b) => (b.disabled = true));
		let sent = false;
		try {
			await this.rate(box.dataset.id, rating);
			sent = true;
		} catch (e) {
			// the opinion is lost, nothing else is
		}
		buttons.forEach((b) => (b.disabled = false));
		if (!sent) return;
		if (rating === "report") {
			button.disabled = true;
		} else {
			box.querySelectorAll(".wsh-assistant__rate-btn").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.rating === rating)));
		}
		box.setAttribute("data-thanks", this.config.labels.thanks);
	},
	//// Neoffice ▲▲▲

	//// Neoffice — the glyph, redrawn (2026-10-30). Was the stock "message in outline" at 24px in a 56px
	//// circle: thin, off-centre, small, and the same on every site. Now a solid speech bubble with a smile
	//// cut out of it. The ink is currentColor (the button's own), the smile is the button's colour so it
	//// reads as a hole whatever colour the shop chose, and the size comes from the stylesheet (30px on
	//// the button, 22px in the header).
	icon() {
		return '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 3.5H16A4.5 4.5 0 0 1 20.5 8V12.5A4.5 4.5 0 0 1 16 17H9.6L4.3 21.2A.5.5 0 0 1 3.5 20.8V8A4.5 4.5 0 0 1 8 3.5Z"/><path fill="none" stroke-width="1.8" stroke-linecap="round" style="stroke: var(--wsh-assistant-color)" d="M8.4 9.7Q12 13.7 15.6 9.7"/></svg>';
	},

	open(remember = true) {
		this.el.panel.hidden = false;
		this.el.bubble.setAttribute("aria-expanded", "true");
		this.el.root.classList.add("is-open");
		if (remember) sessionStorage.setItem("wsh-assistant-open", "1");
		this.scroll();
		setTimeout(() => this.el.input.focus(), 50);
	},

	closePanel() {
		this.el.panel.hidden = true;
		this.el.bubble.setAttribute("aria-expanded", "false");
		this.el.root.classList.remove("is-open");
		sessionStorage.setItem("wsh-assistant-open", "0");
	},

	renderHistory() {
		const c = this.config;
		this.el.messages.innerHTML = "";
		this.addMessage("assistant", c.greeting);
		if (c.history && c.history.length) {
			this.addNote(c.labels.resume);
			c.history.forEach((m) => this.addMessage(m.role, m.content, m.id, m));
			this.el.suggestions.innerHTML = "";
		} else {
			this.renderSuggestions();
		}
		// //// Neoffice ▼▼▼ — the answering machine: notice bar and "leave a message" form when the model is unreachable or a limit is hit, so a stuck visitor still has a way to reach the team (814347b504 "feat(assistant): un répondeur quand le modèle tombe ou la limite est atteinte")
		// the answering machine: the server already knows it cannot answer right now
		if (c.notice && c.notice.reply) {
			this.el.suggestions.innerHTML = "";
			this.addMessage("assistant", c.notice.reply);
			if (c.notice.leave_message) this.showLeaveForm("", c.notice.email_required);
		}
	},

	// The form that reaches the team without the model: shown when the assistant
	// cannot answer, and behind the "talk to the team" link. One at a time.
	showLeaveForm(prefill, emailRequired) {
		const L = this.config.labels;
		const old = this.el.messages.querySelector(".wsh-assistant__leave");
		if (old) old.remove();
		const card = document.createElement("div");
		card.className = "wsh-assistant__leave";
		card.innerHTML =
			`<div class="wsh-assistant__leave-title">${this.escape(L.leave_title)}</div>` +
			`<form class="wsh-assistant__leave-form">` +
			(emailRequired
				? `<input type="email" class="wsh-assistant__leave-email" required maxlength="140" autocomplete="email" placeholder="${this.escape(L.leave_email)}">`
				: "") +
			`<textarea class="wsh-assistant__leave-text" rows="3" required maxlength="1000" placeholder="${this.escape(L.leave_placeholder)}">${this.escape(prefill || "")}</textarea>` +
			`<div class="wsh-assistant__leave-error" hidden></div>` +
			`<div class="wsh-assistant__leave-actions">` +
			`<button type="button" class="wsh-assistant__leave-cancel">${this.escape(L.leave_cancel)}</button>` +
			`<button type="submit" class="wsh-assistant__leave-send">${this.escape(L.leave_send)}</button></div></form>`;
		this.el.messages.appendChild(card);
		const form = card.querySelector("form");
		const text = card.querySelector(".wsh-assistant__leave-text");
		const email = card.querySelector(".wsh-assistant__leave-email");
		const error = card.querySelector(".wsh-assistant__leave-error");
		const button = card.querySelector(".wsh-assistant__leave-send");
		card.querySelector(".wsh-assistant__leave-cancel").addEventListener("click", () => card.remove());
		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			const message = text.value.trim();
			if (!message || (email && !email.value.trim())) return;
			button.disabled = true;
			error.hidden = true;
			try {
				const out = await this.api("webshop.webshop.assistant.api.leave_message", {
					message,
					email: email ? email.value.trim() : undefined,
					page_route: this.route(),
				});
				card.remove();
				this.addMessage("user", message);
				this.addMessage("assistant", (out && out.reply) || L.leave_error);
			} catch (err) {
				error.textContent = this.serverMessage(err) || L.leave_error;
				error.hidden = false;
				button.disabled = false;
			}
		});
		this.scroll();
		setTimeout(() => (email && !email.value ? email : text).focus(), 50);
		return card;
	},

	// What frappe.throw said, if the response carries it; else nothing.
	serverMessage(err) {
		try {
			const raw = err && err.responseJSON && err.responseJSON._server_messages;
			if (!raw) return "";
			const first = JSON.parse(raw)[0];
			const parsed = typeof first === "string" ? JSON.parse(first) : first;
			const tmp = document.createElement("div");
			tmp.innerHTML = (parsed && parsed.message) || "";
			return tmp.textContent.trim();
		} catch (e) {
			return "";
		}
	},
	// //// Neoffice ▲▲▲

	renderSuggestions() {
		const L = this.config.labels;
		this.el.suggestions.innerHTML = L.suggestions
			.map((s) => `<button type="button" class="wsh-assistant__chip">${this.escape(s)}</button>`)
			.join("");
		this.el.suggestions.querySelectorAll(".wsh-assistant__chip").forEach((chip) =>
			chip.addEventListener("click", () => this.send(chip.textContent))
		);
	},

	addMessage(role, text, id, opinion) {
		const div = document.createElement("div");
		div.className = `wsh-assistant__msg wsh-assistant__msg--${role === "user" ? "user" : "assistant"}`;
		div.innerHTML = role === "user" ? this.escape(text) : this.markdown(text);
		//// Neoffice — an answer that has a name in the log can be rated; the greeting and the notices cannot (lot D of the 2026-10-30 audit)
		if (role !== "user" && id) {
			div.insertAdjacentHTML("beforeend", this.rateRowHtml(id, opinion && opinion.feedback, opinion && opinion.reported));
		}
		this.el.messages.appendChild(div);
		this.scroll();
		return div;
	},

	addNote(text) {
		const div = document.createElement("div");
		div.className = "wsh-assistant__note";
		div.textContent = text;
		this.el.messages.appendChild(div);
	},

	typing(on) {
		let t = this.el.messages.querySelector(".wsh-assistant__typing");
		if (on && !t) {
			t = document.createElement("div");
			t.className = "wsh-assistant__typing";
			t.innerHTML = `<span></span><span></span><span></span> <em>${this.escape(this.config.name)} ${this.escape(this.config.labels.typing)}</em>`;
			this.el.messages.appendChild(t);
			this.scroll();
		} else if (!on && t) {
			t.remove();
		}
	},

	async send(text) {
		text = (text || "").trim();
		if (!text || this.busy) return;
		this.busy = true;
		this.el.input.value = "";
		this.el.suggestions.innerHTML = "";
		this.addMessage("user", text);
		this.typing(true);
		try {
			const out = await this.api("webshop.webshop.assistant.api.send", { message: text, page_route: this.route() });
			this.typing(false);
			this.addMessage("assistant", (out && out.reply) || this.config.labels.error, out && !out.unavailable ? out.message_id : null);
			// //// Neoffice — the answering machine: switch to the "leave a message" form once the endpoint itself reports it cannot answer (814347b504 "feat(assistant): un répondeur quand le modèle tombe ou la limite est atteinte")
			// the answering machine: the notice was just shown, now the form, with the words it could not answer
			if (out && out.unavailable && out.leave_message) this.showLeaveForm(text, out.email_required);
		} catch (e) {
			this.typing(false);
			this.addMessage("assistant", this.config.labels.error);
		} finally {
			this.busy = false;
			this.el.input.focus();
		}
	},

	async reset() {
		try {
			await this.api("webshop.webshop.assistant.api.reset", {});
		} catch (e) {
			// a failed reset only means the old thread stays
		}
		this.config.history = [];
		this.renderHistory();
	},

	scroll() {
		this.el.messages.scrollTop = this.el.messages.scrollHeight;
	},

	escape(text) {
		return String(text == null ? "" : text).replace(
			/[&<>"']/g,
			(c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]
		);
	},

	//// Neoffice — lot A of the 2026-10-30 audit. A link the bubble draws goes to THIS shop: a path of the
	//// shop ("/orders/…"; never "//host" or "/\host", which a browser reads as another host) or an absolute
	//// address on this very origin. Before, any address the model wrote became a link, so a model asked to
	//// (or one that read an instruction in a product page) could send the customer anywhere. Anything else
	//// stays readable text. `url` comes escaped from markdown(): "&amp;" is turned back for the check only.
	safeHref(url) {
		const plain = String(url).replace(/&amp;/g, "&");
		if (plain.startsWith("/")) return !/^\/[\/\\]/.test(plain);
		try {
			return new URL(plain).origin === location.origin;
		} catch (e) {
			return false;
		}
	},

	// Bold, links, bullet lists and line breaks: what an answer needs, nothing a
	// model could turn into markup. Everything is escaped first.
	markdown(text) {
		let html = this.escape(text);
		html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
		html = html.replace(/\[([^\]]+)\]\(((?:https?:\/\/|\/)[^\s)]+)\)/g, (m, label, url) =>
			this.safeHref(url) ? `<a href="${url}">${label}</a>` : `${label} (${url})`
		);
		html = html.replace(/(^|[\s(])((?:https?:\/\/[^\s<]+)|(?:\/[a-z0-9][^\s<),.]*))/gi, (m, before, url) =>
			/href="/.test(m) || !this.safeHref(url) ? m : `${before}<a href="${url}">${url}</a>`
		);
		const lines = html.split(/\n/);
		let out = "", inList = false;
		lines.forEach((line) => {
			const item = line.match(/^\s*[-•]\s+(.*)$/);
			if (item) {
				if (!inList) { out += "<ul>"; inList = true; }
				out += `<li>${item[1]}</li>`;
			} else {
				if (inList) { out += "</ul>"; inList = false; }
				out += line.trim() ? `<p>${line}</p>` : "";
			}
		});
		if (inList) out += "</ul>";
		return out;
	},
};

//// Neoffice — was `frappe.ready(() => webshop.assistant.init())`: see whenWanted()
frappe.ready(() => {
	const assistant = webshop.assistant;
	if (assistant.wasOpen()) assistant.init();
	else assistant.whenWanted(() => assistant.init());
});
